const elementIsVisibleInViewport = (el, partiallyVisible = false) => {
  const { top, left, bottom, right } = el.getBoundingClientRect();
  const { innerHeight, innerWidth } = window;
  return partiallyVisible
    ? ((top > 0 && top < innerHeight) ||
        (bottom > 0 && bottom < innerHeight)) &&
        ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
    : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
};

// elementIsVisibleInViewport(el);
// elementIsVisibleInViewport(el, true);

window.addEventListener('scroll',function(){
  if(document.querySelector('.main-product-sc.revised_template .bottom_text_delivery')){
    if(elementIsVisibleInViewport(document.querySelector('.main-product-sc.revised_template .bottom_text_delivery'), true)){
      document.querySelector('.selection_elementMN').classList.remove('makeSticky');
    }else{
      document.querySelector('.selection_elementMN').classList.add('makeSticky');
    }
  }
})